import { render } from "./famousCourseDetail.vue?vue&type=template&id=cd6ef11e&scoped=true"
import script from "./famousCourseDetail.vue?vue&type=script&lang=js"
export * from "./famousCourseDetail.vue?vue&type=script&lang=js"

import "./famousCourseDetail.vue?vue&type=style&index=0&id=cd6ef11e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd6ef11e"]])

export default __exports__